import { defineStore } from 'pinia';
import api from '@/lib/axios';

export const useMenuSimakadStore = defineStore('menuSimakadStore', {
  state: () => ({
    staticNavItems: []
  }),
  actions: {
    async fetchNavItems() {
      try {
        const response = await api.get('website/menu');
        this.staticNavItems = response.data;
      } catch (error) {
        console.error('Failed to fetch navigation items:', error);
      }
    }
  }
});